selectAuthorized